import { object, string } from 'yup';

const resetSchema = object().shape({
  email: string().email('email address is required').required('email address is required'),
});

export default resetSchema;
